import {isString, isInteger, inRange} from 'lodash';

import initializeTierOptions from 'Map/configurer/initializeTierOptions';
import {trafficFlowStyleSchemaParser} from './styleOptionInitialization/tierStyleSchemaParser';
import {isStylePlainObject} from './styleOptionInitialization/validators';
import ThemeWrapper from './styleOptionInitialization/themeWrapper';

const TRAFFIC_FLOW_DEFAULT_THICKNESS = 4;

const validateThickness = (thickness) => {
    const returnValue = thickness || TRAFFIC_FLOW_DEFAULT_THICKNESS;

    if (!(isInteger(returnValue) && inRange(returnValue, 1, 21))) {
        throw new Error('Thickness must be an integer in range from 1 to 20.');
    }

    return returnValue;
};

export default function initializeTrafficFlowOptions(inputOptions) {
    if (!inputOptions) {
        return null;
    }

    const options = {
        ...initializeTierOptions(inputOptions),
        thickness: validateThickness(inputOptions.thickness)
    };
    if (!inputOptions.style) {
        options.theme = trafficFlowStyleSchemaParser('tomtom://vector/1/relative');
    } else if (isStylePlainObject(inputOptions.style)) {
        options.theme = new ThemeWrapper(ThemeWrapper.TYPE.OBJECT, {
            styleObject: inputOptions.style
        });
    } else if (isString(inputOptions.style)) {
        options.theme = trafficFlowStyleSchemaParser(options.style);
    }

    if (!inputOptions.refresh) {
        options.refresh = 180000;
    } else {
        options.refresh = inputOptions.refresh;
        if (options.refresh < 30000) {
            options.refresh = 30000;
        }
    }

    return options;
}



// WEBPACK FOOTER //
// ./map/configurer/initializeTrafficFlowTilesOptions.js